import { sva } from "../../styled-system/css";

export const DialogStyle = sva({
  slots: ["backdrop", "content", "description", "positioner", "title", "window"],
  base: {
    backdrop: {
      backdropFilter: "blur(2px)",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      position: "fixed",
      inset: 0,
    },
    content: {
      backgroundColor: "background",
      borderColor: "border",
      borderStyle: "solid",
      borderWidth: "1px",
      borderRadius: "8px",
      boxShadow: "0 4px 6px -2px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      margin: "24px",
      minWidth: 0,
      overflow: "clip",
      padding: { smDown: "16px", sm: "24px" },
    },
    description: {
      fontWeight: 400,
      fontSize: "14px",
      letterSpacing: 0,
      lineHeight: "20px",
    },
    positioner: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      position: "fixed",
      inset: 0,
    },
    title: {
      color: "foreground",
      fontSize: "18px",
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: "28px",
      minWidth: 0,
      overflow: "clip",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    /** @deprecated 代わりに`content`を使用する。 */
    window: {
      backgroundColor: "background",
      borderColor: "border",
      borderStyle: "solid",
      borderWidth: "1px",
      borderRadius: "8px",
      boxShadow: "0 4px 6px -2px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.1)",
      maxHeight: "100dvh",
      maxWidth: "100dvw",
      padding: "24px",
    },
  },
});
/** @deprecated 代わりに`DialogStyle`を使用する。 */
export const dialogStyles = DialogStyle;
